<script>
    // core components
    import SucursalView from "../../viewsERP/Sucursal.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <SucursalView />
    </div>
  </div>